import { supabase } from "../lib/supabase";

function rowToTravelogue(row) {
  if (!row) return null;
  return {
    id: row.id,
    key: row.key,
    title: row.title || { hr: "", en: "", de: "", es: "" },
    date: row.date,
    image: row.image,
    gallery: Array.isArray(row.gallery) ? row.gallery : [],
    video: row.video || null,
    videos: Array.isArray(row.videos) ? row.videos : [],
    content: row.content || { hr: "", en: "", de: "", es: "" },
    sort_order: row.sort_order,
  };
}

/** Samo stupci koji postoje u tablici `travelogues` (v. supabase/schema.sql). */
function travelogueToRow(t) {
  return {
    key: t.key,
    title: t.title || { hr: "", en: "", de: "", es: "" },
    date: t.date,
    image: t.image ?? "",
    content: t.content || { hr: "", en: "", de: "", es: "" },
    sort_order: t.sort_order != null ? Number(t.sort_order) || 0 : 0,
  };
}

export async function fetchTravelogues() {
  const { data, error } = await supabase
    .from("travelogues")
    .select("*")
    .order("sort_order", { ascending: true })
    .order("date", { ascending: false });

  if (error) {
    console.error("Supabase fetchTravelogues error:", error);
    return null;
  }
  return (data || []).map(rowToTravelogue);
}

export async function createTravelogue(travelogue) {
  const row = travelogueToRow(travelogue);
  const { data, error } = await supabase.from("travelogues").insert(row).select("id").single();
  if (error) {
    console.error("Supabase createTravelogue error:", error);
    return { error };
  }
  return { data: { ...travelogue, id: data.id } };
}

export async function updateTravelogue(travelogue) {
  const { id, ...rest } = travelogue;
  const row = travelogueToRow(rest);
  delete row.sort_order;
  const { error } = await supabase.from("travelogues").update(row).eq("id", id);
  if (error) {
    console.error("Supabase updateTravelogue error:", error);
    return { error };
  }
  return {};
}

export async function deleteTravelogue(id) {
  const { error } = await supabase.from("travelogues").delete().eq("id", id);
  if (error) {
    console.error("Supabase deleteTravelogue error:", error);
    return { error };
  }
  return {};
}
